/* tslint:disable */
/* eslint-disable */
/**
 * Preowned StoreFront API
 * API of the **Search Engine** component that allows querying **Preowned** products by `productId` or `reference`. 
 *
 * The version of the OpenAPI document: 2.2.0
 * Contact: heliolrd@inditex.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BaseSearchValue
 */
export interface BaseSearchValue {
    /**
     * 
     * @type {number}
     * @memberof BaseSearchValue
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseSearchValue
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseSearchValue
     */
    'description'?: string;
    /**
     * 
     * @type {Array<ExtendedSearchValue>}
     * @memberof BaseSearchValue
     */
    'values'?: Array<ExtendedSearchValue>;
    /**
     * 
     * @type {number}
     * @memberof BaseSearchValue
     */
    'productOptionSetSortOrder'?: number;
}
/**
 * 
 * @export
 * @interface ExtendedSearchValue
 */
export interface ExtendedSearchValue {
    /**
     * 
     * @type {number}
     * @memberof ExtendedSearchValue
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedSearchValue
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedSearchValue
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExtendedSearchValue
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedSearchValue
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedSearchValue
     */
    'extra'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendedSearchValue
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {Array<ProductOptionValue>}
     * @memberof ExtendedSearchValue
     */
    'values'?: Array<ProductOptionValue>;
}
/**
 * 
 * @export
 * @interface HybridSearchContent
 */
export interface HybridSearchContent {
    /**
     * Zara catalog identifier for the product
     * @type {number}
     * @memberof HybridSearchContent
     */
    'catalogId'?: number;
    /**
     * Stock keeping unit identifier
     * @type {string}
     * @memberof HybridSearchContent
     */
    'sku'?: string;
    /**
     * Year when the product was released
     * @type {string}
     * @memberof HybridSearchContent
     */
    'year'?: string;
    /**
     * Name of the product
     * @type {string}
     * @memberof HybridSearchContent
     */
    'productName'?: string;
    /**
     * Color description of the product
     * @type {string}
     * @memberof HybridSearchContent
     */
    'colorLabel'?: string;
    /**
     * Collection the product belongs to
     * @type {string}
     * @memberof HybridSearchContent
     */
    'collection'?: string;
    /**
     * URL of the product\'s main image
     * @type {string}
     * @memberof HybridSearchContent
     */
    'frontImage'?: string;
}
/**
 * 
 * @export
 * @interface IaHybridSearch400Response
 */
export interface IaHybridSearch400Response {
    /**
     * 
     * @type {IaHybridSearch400ResponseAllOfExtraData}
     * @memberof IaHybridSearch400Response
     */
    'extraData'?: IaHybridSearch400ResponseAllOfExtraData;
}
/**
 * 
 * @export
 * @interface IaHybridSearch400ResponseAllOf
 */
export interface IaHybridSearch400ResponseAllOf {
    /**
     * 
     * @type {IaHybridSearch400ResponseAllOfExtraData}
     * @memberof IaHybridSearch400ResponseAllOf
     */
    'extraData'?: IaHybridSearch400ResponseAllOfExtraData;
}
/**
 * 
 * @export
 * @interface IaHybridSearch400ResponseAllOfExtraData
 */
export interface IaHybridSearch400ResponseAllOfExtraData {
    [key: string]: any;

    /**
     * Maximum number of IDs allowed in the request.
     * @type {number}
     * @memberof IaHybridSearch400ResponseAllOfExtraData
     */
    'maxAllowedIds'?: number;
    /**
     * Number of IDs actually provided in the request.
     * @type {number}
     * @memberof IaHybridSearch400ResponseAllOfExtraData
     */
    'providedIds'?: number;
}
/**
 * Cached image-search page grouped by visual subfamily. It does not include cacheReference because the client already has it.
 * @export
 * @interface ImageSearchPageResponse
 */
export interface ImageSearchPageResponse {
    /**
     * Groups ordered by visual relevance for this cached page.
     * @type {Array<SubfamilyGroup>}
     * @memberof ImageSearchPageResponse
     */
    'subfamilyGroups': Array<SubfamilyGroup>;
}
/**
 * Product or product group candidate returned by image search, with the same identifier semantics as the group search response. Products are ordered by IA visual relevance inside each subfamily.
 * @export
 * @interface ImageSearchProduct
 */
export interface ImageSearchProduct {
    /**
     * Product or product group identifier as returned by the group search flow.
     * @type {number}
     * @memberof ImageSearchProduct
     */
    'id': number;
    /**
     * Indicates whether this candidate represents a product group.
     * @type {boolean}
     * @memberof ImageSearchProduct
     */
    'isGroup': boolean;
    /**
     * Business reference of the product group as returned by the group search flow.
     * @type {number}
     * @memberof ImageSearchProduct
     */
    'groupReference': number;
    /**
     * Type of group returned by the catalog enrichment.
     * @type {string}
     * @memberof ImageSearchProduct
     */
    'groupType'?: string | null;
    /**
     * Localized description of the product or product group.
     * @type {string}
     * @memberof ImageSearchProduct
     */
    'groupDescription'?: string | null;
    /**
     * Front image URL of the product or product group.
     * @type {string}
     * @memberof ImageSearchProduct
     */
    'groupFrontImage'?: string | null;
    /**
     * Localized title of the product or product group.
     * @type {string}
     * @memberof ImageSearchProduct
     */
    'groupTitle'?: string | null;
    /**
     * Store identifier where the product or group is available.
     * @type {number}
     * @memberof ImageSearchProduct
     */
    'store'?: number;
    /**
     * Available product sizes for the product or product group.
     * @type {Array<ProductSize>}
     * @memberof ImageSearchProduct
     */
    'sizes': Array<ProductSize>;
    /**
     * 
     * @type {ProductPrices}
     * @memberof ImageSearchProduct
     */
    'prices': ProductPrices;
    /**
     * Grid identifiers associated with the product or product group.
     * @type {Array<string>}
     * @memberof ImageSearchProduct
     */
    'grids': Array<string>;
    /**
     * Universes associated with the product or product group.
     * @type {Array<string>}
     * @memberof ImageSearchProduct
     */
    'universes': Array<string>;
}
/**
 * First image-search response grouped by visual subfamily, including a cache reference for subsequent pagination.
 * @export
 * @interface ImageSearchResponse
 */
export interface ImageSearchResponse {
    /**
     * Opaque reference for subsequent cached-page requests. Valid for approximately 10 minutes.
     * @type {string}
     * @memberof ImageSearchResponse
     */
    'cacheReference': string;
    /**
     * Groups ordered by visual relevance. Products inside each group are also ordered by visual relevance.
     * @type {Array<SubfamilyGroup>}
     * @memberof ImageSearchResponse
     */
    'subfamilyGroups': Array<SubfamilyGroup>;
}
/**
 * Problem detail response for StoreFront errors.
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * Application error code or problem type.
     * @type {string}
     * @memberof ModelError
     */
    'type': string;
    /**
     * Short, human-readable summary of the problem.
     * @type {string}
     * @memberof ModelError
     */
    'title': string;
    /**
     * HTTP status code generated by the origin server.
     * @type {number}
     * @memberof ModelError
     */
    'status': number;
    /**
     * Human-readable explanation specific to this occurrence of the problem.
     * @type {string}
     * @memberof ModelError
     */
    'detail': string;
    /**
     * Timestamp when the error was generated.
     * @type {string}
     * @memberof ModelError
     */
    'timestamp'?: string;
    /**
     * Optional structured diagnostic data.
     * @type {{ [key: string]: any; }}
     * @memberof ModelError
     */
    'extraData'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface PreownedProductsResponse
 */
export interface PreownedProductsResponse {
    /**
     * 
     * @type {PreownedProductsResponseMetadata}
     * @memberof PreownedProductsResponse
     */
    'metadata'?: PreownedProductsResponseMetadata;
    /**
     * 
     * @type {Array<PreownedProductsResponseProductsInner>}
     * @memberof PreownedProductsResponse
     */
    'products': Array<PreownedProductsResponseProductsInner>;
}
/**
 * Pagination and results information
 * @export
 * @interface PreownedProductsResponseMetadata
 */
export interface PreownedProductsResponseMetadata {
    /**
     * 
     * @type {number}
     * @memberof PreownedProductsResponseMetadata
     */
    'totalItems'?: number;
    /**
     * 
     * @type {number}
     * @memberof PreownedProductsResponseMetadata
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PreownedProductsResponseMetadata
     */
    'currentPage'?: number;
}
/**
 * 
 * @export
 * @interface PreownedProductsResponseProductsInner
 */
export interface PreownedProductsResponseProductsInner {
    /**
     * 
     * @type {object}
     * @memberof PreownedProductsResponseProductsInner
     */
    'product'?: object;
    /**
     * Public URL of the Preowned product
     * @type {string}
     * @memberof PreownedProductsResponseProductsInner
     */
    'productUrl'?: string;
}
/**
 * 
 * @export
 * @interface ProductOptionValue
 */
export interface ProductOptionValue {
    /**
     * 
     * @type {number}
     * @memberof ProductOptionValue
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionValue
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionValue
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionValue
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionValue
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionValue
     */
    'extra'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductOptionValue
     */
    'disabled'?: boolean;
}
/**
 * Monetary amount expressed in minor units.
 * @export
 * @interface ProductPriceDto
 */
export interface ProductPriceDto {
    /**
     * ISO 4217 currency code.
     * @type {string}
     * @memberof ProductPriceDto
     */
    'currency': string;
    /**
     * Monetary value expressed in minor units.
     * @type {number}
     * @memberof ProductPriceDto
     */
    'value': number;
    /**
     * Number of decimal digits used by the currency minor unit.
     * @type {number}
     * @memberof ProductPriceDto
     */
    'exponent': number;
}
/**
 * Minimum and maximum price range for a product or product group.
 * @export
 * @interface ProductPrices
 */
export interface ProductPrices {
    /**
     * 
     * @type {ProductPriceDto}
     * @memberof ProductPrices
     */
    'min': ProductPriceDto;
    /**
     * 
     * @type {ProductPriceDto}
     * @memberof ProductPrices
     */
    'max': ProductPriceDto;
}
/**
 * Aggregated size availability for a product or product group.
 * @export
 * @interface ProductSize
 */
export interface ProductSize {
    /**
     * Size identifier.
     * @type {number}
     * @memberof ProductSize
     */
    'id': number;
    /**
     * Number of product variants available for this size.
     * @type {number}
     * @memberof ProductSize
     */
    'count': number;
    /**
     * Indicates whether this size matched an explicit search hit.
     * @type {boolean}
     * @memberof ProductSize
     */
    'isHit': boolean;
}
/**
 * 
 * @export
 * @interface SearchFields
 */
export interface SearchFields {
    /**
     * 
     * @type {string}
     * @memberof SearchFields
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchFields
     */
    'categoryName'?: string;
    /**
     * 
     * @type {Array<BaseSearchValue>}
     * @memberof SearchFields
     */
    'values'?: Array<BaseSearchValue>;
    /**
     * 
     * @type {string}
     * @memberof SearchFields
     */
    'fieldName'?: string;
}
/**
 * 
 * @export
 * @interface SearchOptions
 */
export interface SearchOptions {
    /**
     * 
     * @type {Array<SearchSort>}
     * @memberof SearchOptions
     */
    'sorting'?: Array<SearchSort>;
    /**
     * 
     * @type {Array<SearchFields>}
     * @memberof SearchOptions
     */
    'filters'?: Array<SearchFields>;
}
/**
 * 
 * @export
 * @interface SearchSort
 */
export interface SearchSort {
    /**
     * 
     * @type {string}
     * @memberof SearchSort
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSort
     */
    'categoryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSort
     */
    'fieldName'?: string;
}
/**
 * Products grouped by IA visual subfamily.
 * @export
 * @interface SubfamilyGroup
 */
export interface SubfamilyGroup {
    /**
     * Visual subfamily label from IA classification.
     * @type {string}
     * @memberof SubfamilyGroup
     */
    'subfamily': string;
    /**
     * Products belonging to this visual subfamily, ordered by visual relevance.
     * @type {Array<ImageSearchProduct>}
     * @memberof SubfamilyGroup
     */
    'products': Array<ImageSearchProduct>;
}

/**
 * IaHybridSearchFrontApi - axios parameter creator
 * @export
 */
export const IaHybridSearchFrontApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a page of image-search results previously created by the image-search POST operation, using the opaque cache reference returned in that first response. This endpoint does not re-upload the image and does not re-run visual search. Products that are no longer visible are omitted while preserving the original visual-search order among visible products. If the cache reference expired, clients must repeat the POST image-search request. 
         * @summary Get a cached page of image search results
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} cacheReference Opaque cache reference returned by the image-search POST response
         * @param {number} [page] Zero-based page index to retrieve from the cached result set
         * @param {number} [size] Number of products requested for the cached page
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageSearchCandidatesPage: async (storeId: number, cacheReference: string, page?: number, size?: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getImageSearchCandidatesPage', 'storeId', storeId)
            // verify required parameter 'cacheReference' is not null or undefined
            assertParamExists('getImageSearchCandidatesPage', 'cacheReference', cacheReference)
            const localVarPath = `/api/storefront/1/stores/{storeId}/preowned-catalog/image-search-candidates/{cacheReference}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"cacheReference"}}`, encodeURIComponent(String(cacheReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint allows you to perform an IA hybrid search by uploading an image along with optional  parameters such as \'year\' (to filter results by year). The response will include a list of products that are visually similar to the uploaded image, along with their details. Large images can be uploaded (up to 50MB) due to the high resolution of current mobile phone cameras, as users will typically take photos of garments directly with their mobile devices. 
         * @summary get ia hybrid search results from given data
         * @param {number} storeId ID of the store this query is directed to
         * @param {File} uploadedImage Image file to be uploaded for the search with a supported format (JPEG, PNG). Large images can be uploaded due to the high resolution of current mobile phone cameras, as this field will carry the photo that the user takes of the garment.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iaHybridSearch: async (storeId: number, uploadedImage: File, lang?: string, year?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('iaHybridSearch', 'storeId', storeId)
            // verify required parameter 'uploadedImage' is not null or undefined
            assertParamExists('iaHybridSearch', 'uploadedImage', uploadedImage)
            const localVarPath = `/api/storefront/1/stores/{storeId}/preowned-catalog/searchia-candidates`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


            if (uploadedImage !== undefined) { 
                localVarFormParams.append('uploadedImage', uploadedImage as any);
            }
    
            if (year !== undefined) { 
                localVarFormParams.append('year', year as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint allows you to perform an IA image search by uploading an image along with optional parameters such as \'year\' (to enrich the response metadata), \'section\', \'k\', \'searchMode\' and \'maxDim\'. The response includes products that are visually similar to the uploaded image, grouped by visual subfamily, and an opaque cache reference for browsing subsequent pages without uploading the image again. Large images can be uploaded (up to 50MB) due to the high resolution of current mobile phone cameras, as users will typically take photos of garments directly with their mobile devices. 
         * @summary Search preowned candidates by image
         * @param {number} storeId ID of the store this query is directed to
         * @param {File} uploadedImage Image file to be uploaded for the search. Supported formats are JPEG and PNG. Maximum size is 50MB.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [year] Optional year metadata to include in product response enrichment.
         * @param {string} [section] Storefront section used to constrain visual search. Valid values are WOMAN, MAN and KID.
         * @param {number} [k] Maximum number of products returned per visual subfamily.
         * @param {string} [searchMode] Visual-search mode applied to the uploaded image. Valid values are crop and simple.
         * @param {number} [maxDim] Maximum image dimension used by the visual-search preprocessing pipeline. Valid values are 256, 512, 768 and 1024.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchImageCandidates: async (storeId: number, uploadedImage: File, lang?: string, year?: number, section?: string, k?: number, searchMode?: string, maxDim?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('searchImageCandidates', 'storeId', storeId)
            // verify required parameter 'uploadedImage' is not null or undefined
            assertParamExists('searchImageCandidates', 'uploadedImage', uploadedImage)
            const localVarPath = `/api/storefront/1/stores/{storeId}/preowned-catalog/image-search-candidates`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


            if (uploadedImage !== undefined) { 
                localVarFormParams.append('uploadedImage', uploadedImage as any);
            }
    
            if (year !== undefined) { 
                localVarFormParams.append('year', year as any);
            }
    
            if (section !== undefined) { 
                localVarFormParams.append('section', section as any);
            }
    
            if (k !== undefined) { 
                localVarFormParams.append('k', k as any);
            }
    
            if (searchMode !== undefined) { 
                localVarFormParams.append('searchMode', searchMode as any);
            }
    
            if (maxDim !== undefined) { 
                localVarFormParams.append('maxDim', maxDim as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IaHybridSearchFrontApi - functional programming interface
 * @export
 */
export const IaHybridSearchFrontApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IaHybridSearchFrontApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a page of image-search results previously created by the image-search POST operation, using the opaque cache reference returned in that first response. This endpoint does not re-upload the image and does not re-run visual search. Products that are no longer visible are omitted while preserving the original visual-search order among visible products. If the cache reference expired, clients must repeat the POST image-search request. 
         * @summary Get a cached page of image search results
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} cacheReference Opaque cache reference returned by the image-search POST response
         * @param {number} [page] Zero-based page index to retrieve from the cached result set
         * @param {number} [size] Number of products requested for the cached page
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageSearchCandidatesPage(storeId: number, cacheReference: string, page?: number, size?: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageSearchPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageSearchCandidatesPage(storeId, cacheReference, page, size, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint allows you to perform an IA hybrid search by uploading an image along with optional  parameters such as \'year\' (to filter results by year). The response will include a list of products that are visually similar to the uploaded image, along with their details. Large images can be uploaded (up to 50MB) due to the high resolution of current mobile phone cameras, as users will typically take photos of garments directly with their mobile devices. 
         * @summary get ia hybrid search results from given data
         * @param {number} storeId ID of the store this query is directed to
         * @param {File} uploadedImage Image file to be uploaded for the search with a supported format (JPEG, PNG). Large images can be uploaded due to the high resolution of current mobile phone cameras, as this field will carry the photo that the user takes of the garment.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async iaHybridSearch(storeId: number, uploadedImage: File, lang?: string, year?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HybridSearchContent>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.iaHybridSearch(storeId, uploadedImage, lang, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint allows you to perform an IA image search by uploading an image along with optional parameters such as \'year\' (to enrich the response metadata), \'section\', \'k\', \'searchMode\' and \'maxDim\'. The response includes products that are visually similar to the uploaded image, grouped by visual subfamily, and an opaque cache reference for browsing subsequent pages without uploading the image again. Large images can be uploaded (up to 50MB) due to the high resolution of current mobile phone cameras, as users will typically take photos of garments directly with their mobile devices. 
         * @summary Search preowned candidates by image
         * @param {number} storeId ID of the store this query is directed to
         * @param {File} uploadedImage Image file to be uploaded for the search. Supported formats are JPEG and PNG. Maximum size is 50MB.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [year] Optional year metadata to include in product response enrichment.
         * @param {string} [section] Storefront section used to constrain visual search. Valid values are WOMAN, MAN and KID.
         * @param {number} [k] Maximum number of products returned per visual subfamily.
         * @param {string} [searchMode] Visual-search mode applied to the uploaded image. Valid values are crop and simple.
         * @param {number} [maxDim] Maximum image dimension used by the visual-search preprocessing pipeline. Valid values are 256, 512, 768 and 1024.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchImageCandidates(storeId: number, uploadedImage: File, lang?: string, year?: number, section?: string, k?: number, searchMode?: string, maxDim?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchImageCandidates(storeId, uploadedImage, lang, year, section, k, searchMode, maxDim, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IaHybridSearchFrontApi - factory interface
 * @export
 */
export const IaHybridSearchFrontApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IaHybridSearchFrontApiFp(configuration)
    return {
        /**
         * Returns a page of image-search results previously created by the image-search POST operation, using the opaque cache reference returned in that first response. This endpoint does not re-upload the image and does not re-run visual search. Products that are no longer visible are omitted while preserving the original visual-search order among visible products. If the cache reference expired, clients must repeat the POST image-search request. 
         * @summary Get a cached page of image search results
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} cacheReference Opaque cache reference returned by the image-search POST response
         * @param {number} [page] Zero-based page index to retrieve from the cached result set
         * @param {number} [size] Number of products requested for the cached page
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageSearchCandidatesPage(storeId: number, cacheReference: string, page?: number, size?: number, lang?: string, options?: any): AxiosPromise<ImageSearchPageResponse> {
            return localVarFp.getImageSearchCandidatesPage(storeId, cacheReference, page, size, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows you to perform an IA hybrid search by uploading an image along with optional  parameters such as \'year\' (to filter results by year). The response will include a list of products that are visually similar to the uploaded image, along with their details. Large images can be uploaded (up to 50MB) due to the high resolution of current mobile phone cameras, as users will typically take photos of garments directly with their mobile devices. 
         * @summary get ia hybrid search results from given data
         * @param {number} storeId ID of the store this query is directed to
         * @param {File} uploadedImage Image file to be uploaded for the search with a supported format (JPEG, PNG). Large images can be uploaded due to the high resolution of current mobile phone cameras, as this field will carry the photo that the user takes of the garment.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iaHybridSearch(storeId: number, uploadedImage: File, lang?: string, year?: number, options?: any): AxiosPromise<Array<HybridSearchContent>> {
            return localVarFp.iaHybridSearch(storeId, uploadedImage, lang, year, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows you to perform an IA image search by uploading an image along with optional parameters such as \'year\' (to enrich the response metadata), \'section\', \'k\', \'searchMode\' and \'maxDim\'. The response includes products that are visually similar to the uploaded image, grouped by visual subfamily, and an opaque cache reference for browsing subsequent pages without uploading the image again. Large images can be uploaded (up to 50MB) due to the high resolution of current mobile phone cameras, as users will typically take photos of garments directly with their mobile devices. 
         * @summary Search preowned candidates by image
         * @param {number} storeId ID of the store this query is directed to
         * @param {File} uploadedImage Image file to be uploaded for the search. Supported formats are JPEG and PNG. Maximum size is 50MB.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [year] Optional year metadata to include in product response enrichment.
         * @param {string} [section] Storefront section used to constrain visual search. Valid values are WOMAN, MAN and KID.
         * @param {number} [k] Maximum number of products returned per visual subfamily.
         * @param {string} [searchMode] Visual-search mode applied to the uploaded image. Valid values are crop and simple.
         * @param {number} [maxDim] Maximum image dimension used by the visual-search preprocessing pipeline. Valid values are 256, 512, 768 and 1024.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchImageCandidates(storeId: number, uploadedImage: File, lang?: string, year?: number, section?: string, k?: number, searchMode?: string, maxDim?: number, options?: any): AxiosPromise<ImageSearchResponse> {
            return localVarFp.searchImageCandidates(storeId, uploadedImage, lang, year, section, k, searchMode, maxDim, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IaHybridSearchFrontApi - interface
 * @export
 * @interface IaHybridSearchFrontApi
 */
export interface IaHybridSearchFrontApiInterface {
    /**
     * Returns a page of image-search results previously created by the image-search POST operation, using the opaque cache reference returned in that first response. This endpoint does not re-upload the image and does not re-run visual search. Products that are no longer visible are omitted while preserving the original visual-search order among visible products. If the cache reference expired, clients must repeat the POST image-search request. 
     * @summary Get a cached page of image search results
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} cacheReference Opaque cache reference returned by the image-search POST response
     * @param {number} [page] Zero-based page index to retrieve from the cached result set
     * @param {number} [size] Number of products requested for the cached page
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaHybridSearchFrontApiInterface
     */
    getImageSearchCandidatesPage(storeId: number, cacheReference: string, page?: number, size?: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ImageSearchPageResponse>;

    /**
     * This endpoint allows you to perform an IA hybrid search by uploading an image along with optional  parameters such as \'year\' (to filter results by year). The response will include a list of products that are visually similar to the uploaded image, along with their details. Large images can be uploaded (up to 50MB) due to the high resolution of current mobile phone cameras, as users will typically take photos of garments directly with their mobile devices. 
     * @summary get ia hybrid search results from given data
     * @param {number} storeId ID of the store this query is directed to
     * @param {File} uploadedImage Image file to be uploaded for the search with a supported format (JPEG, PNG). Large images can be uploaded due to the high resolution of current mobile phone cameras, as this field will carry the photo that the user takes of the garment.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaHybridSearchFrontApiInterface
     */
    iaHybridSearch(storeId: number, uploadedImage: File, lang?: string, year?: number, options?: AxiosRequestConfig): AxiosPromise<Array<HybridSearchContent>>;

    /**
     * This endpoint allows you to perform an IA image search by uploading an image along with optional parameters such as \'year\' (to enrich the response metadata), \'section\', \'k\', \'searchMode\' and \'maxDim\'. The response includes products that are visually similar to the uploaded image, grouped by visual subfamily, and an opaque cache reference for browsing subsequent pages without uploading the image again. Large images can be uploaded (up to 50MB) due to the high resolution of current mobile phone cameras, as users will typically take photos of garments directly with their mobile devices. 
     * @summary Search preowned candidates by image
     * @param {number} storeId ID of the store this query is directed to
     * @param {File} uploadedImage Image file to be uploaded for the search. Supported formats are JPEG and PNG. Maximum size is 50MB.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [year] Optional year metadata to include in product response enrichment.
     * @param {string} [section] Storefront section used to constrain visual search. Valid values are WOMAN, MAN and KID.
     * @param {number} [k] Maximum number of products returned per visual subfamily.
     * @param {string} [searchMode] Visual-search mode applied to the uploaded image. Valid values are crop and simple.
     * @param {number} [maxDim] Maximum image dimension used by the visual-search preprocessing pipeline. Valid values are 256, 512, 768 and 1024.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaHybridSearchFrontApiInterface
     */
    searchImageCandidates(storeId: number, uploadedImage: File, lang?: string, year?: number, section?: string, k?: number, searchMode?: string, maxDim?: number, options?: AxiosRequestConfig): AxiosPromise<ImageSearchResponse>;

}

/**
 * IaHybridSearchFrontApi - object-oriented interface
 * @export
 * @class IaHybridSearchFrontApi
 * @extends {BaseAPI}
 */
export class IaHybridSearchFrontApi extends BaseAPI implements IaHybridSearchFrontApiInterface {
    /**
     * Returns a page of image-search results previously created by the image-search POST operation, using the opaque cache reference returned in that first response. This endpoint does not re-upload the image and does not re-run visual search. Products that are no longer visible are omitted while preserving the original visual-search order among visible products. If the cache reference expired, clients must repeat the POST image-search request. 
     * @summary Get a cached page of image search results
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} cacheReference Opaque cache reference returned by the image-search POST response
     * @param {number} [page] Zero-based page index to retrieve from the cached result set
     * @param {number} [size] Number of products requested for the cached page
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaHybridSearchFrontApi
     */
    public getImageSearchCandidatesPage(storeId: number, cacheReference: string, page?: number, size?: number, lang?: string, options?: AxiosRequestConfig) {
        return IaHybridSearchFrontApiFp(this.configuration).getImageSearchCandidatesPage(storeId, cacheReference, page, size, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint allows you to perform an IA hybrid search by uploading an image along with optional  parameters such as \'year\' (to filter results by year). The response will include a list of products that are visually similar to the uploaded image, along with their details. Large images can be uploaded (up to 50MB) due to the high resolution of current mobile phone cameras, as users will typically take photos of garments directly with their mobile devices. 
     * @summary get ia hybrid search results from given data
     * @param {number} storeId ID of the store this query is directed to
     * @param {File} uploadedImage Image file to be uploaded for the search with a supported format (JPEG, PNG). Large images can be uploaded due to the high resolution of current mobile phone cameras, as this field will carry the photo that the user takes of the garment.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaHybridSearchFrontApi
     */
    public iaHybridSearch(storeId: number, uploadedImage: File, lang?: string, year?: number, options?: AxiosRequestConfig) {
        return IaHybridSearchFrontApiFp(this.configuration).iaHybridSearch(storeId, uploadedImage, lang, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint allows you to perform an IA image search by uploading an image along with optional parameters such as \'year\' (to enrich the response metadata), \'section\', \'k\', \'searchMode\' and \'maxDim\'. The response includes products that are visually similar to the uploaded image, grouped by visual subfamily, and an opaque cache reference for browsing subsequent pages without uploading the image again. Large images can be uploaded (up to 50MB) due to the high resolution of current mobile phone cameras, as users will typically take photos of garments directly with their mobile devices. 
     * @summary Search preowned candidates by image
     * @param {number} storeId ID of the store this query is directed to
     * @param {File} uploadedImage Image file to be uploaded for the search. Supported formats are JPEG and PNG. Maximum size is 50MB.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [year] Optional year metadata to include in product response enrichment.
     * @param {string} [section] Storefront section used to constrain visual search. Valid values are WOMAN, MAN and KID.
     * @param {number} [k] Maximum number of products returned per visual subfamily.
     * @param {string} [searchMode] Visual-search mode applied to the uploaded image. Valid values are crop and simple.
     * @param {number} [maxDim] Maximum image dimension used by the visual-search preprocessing pipeline. Valid values are 256, 512, 768 and 1024.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaHybridSearchFrontApi
     */
    public searchImageCandidates(storeId: number, uploadedImage: File, lang?: string, year?: number, section?: string, k?: number, searchMode?: string, maxDim?: number, options?: AxiosRequestConfig) {
        return IaHybridSearchFrontApiFp(this.configuration).searchImageCandidates(storeId, uploadedImage, lang, year, section, k, searchMode, maxDim, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductSearchApi - axios parameter creator
 * @export
 */
export const ProductSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns information about one or more Preowned products using the Zara product identifier (`id`) or reference (`reference`). **Matching rules:** - If searching by `id` (productId), it will match the `catalogId` field in Preowned. - If searching by `reference`, it will match the `sku` field in Preowned. - Only **one of the two parameters** should be provided. If no results are found, a   `200 OK` is returned with `totalItems: 0` and an empty list. - Supports pagination for handling large volumes of data. 
         * @summary Search Preowned products by productId or reference
         * @param {object} storeId Store ID
         * @param {string} [catalogIds] One or more Zara product identifiers (&#x60;productId&#x60;), separated by commas. The search will match the &#x60;catalogId&#x60; field in Preowned. Maximum allowed: 185 IDs or 2000 characters. Only this parameter or &#x60;references&#x60; can be sent, not both. 
         * @param {string} [references] Regular expression by garment type, brand, and season, it will not accept the size field. Maximum allowed: 185 references or 2000 characters. Only this parameter or &#x60;catalogIds&#x60; can be sent, not both. 
         * @param {string} [preownedIds] One or more unique Preowned identifiers, separated by commas. The search will match the &#x60;product.id&#x60; field in Preowned. Maximum allowed: 185 IDs or 2000 characters. Only this parameter, &#x60;catalogIds&#x60;, or &#x60;references&#x60; can be sent, not more than one. 
         * @param {number} [pageNumber] Page index (0..N).
         * @param {number} [pageSize] Number of items per page.
         * @param {string} [language] Language code for the response content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreownedProductsByIdOrReference: async (storeId: object, catalogIds?: string, references?: string, preownedIds?: string, pageNumber?: number, pageSize?: number, language?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getPreownedProductsByIdOrReference', 'storeId', storeId)
            const localVarPath = `/api/v1/storefront/stores/{storeId}/preowned-products`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (catalogIds !== undefined) {
                localVarQueryParameter['catalogIds'] = catalogIds;
            }

            if (references !== undefined) {
                localVarQueryParameter['references'] = references;
            }

            if (preownedIds !== undefined) {
                localVarQueryParameter['preownedIds'] = preownedIds;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns filters based on actual search results to improve user experience by showing only relevant filter options
         * @summary Get contextual filters for products based on search criteria
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] Search query string to filter results
         * @param {number} [minPublicationDateInMillis] Minimum publication date in milliseconds
         * @param {number} [maxPublicationDateInMillis] Maximum publication date in milliseconds
         * @param {Array<number>} [universeId] Universe identifier(s) to filter by
         * @param {Array<number>} [sizeId] Size identifier(s) to filter by
         * @param {Array<number>} [colorId] Color identifier(s) to filter by
         * @param {Array<number>} [conditionId] Condition identifier(s) to filter by
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {Array<number>} [categoryId] Category identifier(s) to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSearchFiltersBySearch: async (storeId: number, query?: string, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, sizeId?: Array<number>, colorId?: Array<number>, conditionId?: Array<number>, sort?: Array<string>, lang?: string, categoryId?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getProductSearchFiltersBySearch', 'storeId', storeId)
            const localVarPath = `/api/preowned-web/1/stores/{storeId}/products/filters`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (minPublicationDateInMillis !== undefined) {
                localVarQueryParameter['minPublicationDateInMillis'] = minPublicationDateInMillis;
            }

            if (maxPublicationDateInMillis !== undefined) {
                localVarQueryParameter['maxPublicationDateInMillis'] = maxPublicationDateInMillis;
            }

            if (universeId) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (sizeId) {
                localVarQueryParameter['sizeId'] = sizeId;
            }

            if (colorId) {
                localVarQueryParameter['colorId'] = colorId;
            }

            if (conditionId) {
                localVarQueryParameter['conditionId'] = conditionId;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (categoryId) {
                localVarQueryParameter['categoryId'] = categoryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductSearchApi - functional programming interface
 * @export
 */
export const ProductSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns information about one or more Preowned products using the Zara product identifier (`id`) or reference (`reference`). **Matching rules:** - If searching by `id` (productId), it will match the `catalogId` field in Preowned. - If searching by `reference`, it will match the `sku` field in Preowned. - Only **one of the two parameters** should be provided. If no results are found, a   `200 OK` is returned with `totalItems: 0` and an empty list. - Supports pagination for handling large volumes of data. 
         * @summary Search Preowned products by productId or reference
         * @param {object} storeId Store ID
         * @param {string} [catalogIds] One or more Zara product identifiers (&#x60;productId&#x60;), separated by commas. The search will match the &#x60;catalogId&#x60; field in Preowned. Maximum allowed: 185 IDs or 2000 characters. Only this parameter or &#x60;references&#x60; can be sent, not both. 
         * @param {string} [references] Regular expression by garment type, brand, and season, it will not accept the size field. Maximum allowed: 185 references or 2000 characters. Only this parameter or &#x60;catalogIds&#x60; can be sent, not both. 
         * @param {string} [preownedIds] One or more unique Preowned identifiers, separated by commas. The search will match the &#x60;product.id&#x60; field in Preowned. Maximum allowed: 185 IDs or 2000 characters. Only this parameter, &#x60;catalogIds&#x60;, or &#x60;references&#x60; can be sent, not more than one. 
         * @param {number} [pageNumber] Page index (0..N).
         * @param {number} [pageSize] Number of items per page.
         * @param {string} [language] Language code for the response content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreownedProductsByIdOrReference(storeId: object, catalogIds?: string, references?: string, preownedIds?: string, pageNumber?: number, pageSize?: number, language?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreownedProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreownedProductsByIdOrReference(storeId, catalogIds, references, preownedIds, pageNumber, pageSize, language, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns filters based on actual search results to improve user experience by showing only relevant filter options
         * @summary Get contextual filters for products based on search criteria
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] Search query string to filter results
         * @param {number} [minPublicationDateInMillis] Minimum publication date in milliseconds
         * @param {number} [maxPublicationDateInMillis] Maximum publication date in milliseconds
         * @param {Array<number>} [universeId] Universe identifier(s) to filter by
         * @param {Array<number>} [sizeId] Size identifier(s) to filter by
         * @param {Array<number>} [colorId] Color identifier(s) to filter by
         * @param {Array<number>} [conditionId] Condition identifier(s) to filter by
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {Array<number>} [categoryId] Category identifier(s) to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSearchFiltersBySearch(storeId: number, query?: string, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, sizeId?: Array<number>, colorId?: Array<number>, conditionId?: Array<number>, sort?: Array<string>, lang?: string, categoryId?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSearchFiltersBySearch(storeId, query, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, sizeId, colorId, conditionId, sort, lang, categoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductSearchApi - factory interface
 * @export
 */
export const ProductSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductSearchApiFp(configuration)
    return {
        /**
         * Returns information about one or more Preowned products using the Zara product identifier (`id`) or reference (`reference`). **Matching rules:** - If searching by `id` (productId), it will match the `catalogId` field in Preowned. - If searching by `reference`, it will match the `sku` field in Preowned. - Only **one of the two parameters** should be provided. If no results are found, a   `200 OK` is returned with `totalItems: 0` and an empty list. - Supports pagination for handling large volumes of data. 
         * @summary Search Preowned products by productId or reference
         * @param {object} storeId Store ID
         * @param {string} [catalogIds] One or more Zara product identifiers (&#x60;productId&#x60;), separated by commas. The search will match the &#x60;catalogId&#x60; field in Preowned. Maximum allowed: 185 IDs or 2000 characters. Only this parameter or &#x60;references&#x60; can be sent, not both. 
         * @param {string} [references] Regular expression by garment type, brand, and season, it will not accept the size field. Maximum allowed: 185 references or 2000 characters. Only this parameter or &#x60;catalogIds&#x60; can be sent, not both. 
         * @param {string} [preownedIds] One or more unique Preowned identifiers, separated by commas. The search will match the &#x60;product.id&#x60; field in Preowned. Maximum allowed: 185 IDs or 2000 characters. Only this parameter, &#x60;catalogIds&#x60;, or &#x60;references&#x60; can be sent, not more than one. 
         * @param {number} [pageNumber] Page index (0..N).
         * @param {number} [pageSize] Number of items per page.
         * @param {string} [language] Language code for the response content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreownedProductsByIdOrReference(storeId: object, catalogIds?: string, references?: string, preownedIds?: string, pageNumber?: number, pageSize?: number, language?: string, options?: any): AxiosPromise<PreownedProductsResponse> {
            return localVarFp.getPreownedProductsByIdOrReference(storeId, catalogIds, references, preownedIds, pageNumber, pageSize, language, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns filters based on actual search results to improve user experience by showing only relevant filter options
         * @summary Get contextual filters for products based on search criteria
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [query] Search query string to filter results
         * @param {number} [minPublicationDateInMillis] Minimum publication date in milliseconds
         * @param {number} [maxPublicationDateInMillis] Maximum publication date in milliseconds
         * @param {Array<number>} [universeId] Universe identifier(s) to filter by
         * @param {Array<number>} [sizeId] Size identifier(s) to filter by
         * @param {Array<number>} [colorId] Color identifier(s) to filter by
         * @param {Array<number>} [conditionId] Condition identifier(s) to filter by
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {Array<number>} [categoryId] Category identifier(s) to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSearchFiltersBySearch(storeId: number, query?: string, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, sizeId?: Array<number>, colorId?: Array<number>, conditionId?: Array<number>, sort?: Array<string>, lang?: string, categoryId?: Array<number>, options?: any): AxiosPromise<SearchOptions> {
            return localVarFp.getProductSearchFiltersBySearch(storeId, query, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, sizeId, colorId, conditionId, sort, lang, categoryId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductSearchApi - interface
 * @export
 * @interface ProductSearchApi
 */
export interface ProductSearchApiInterface {
    /**
     * Returns information about one or more Preowned products using the Zara product identifier (`id`) or reference (`reference`). **Matching rules:** - If searching by `id` (productId), it will match the `catalogId` field in Preowned. - If searching by `reference`, it will match the `sku` field in Preowned. - Only **one of the two parameters** should be provided. If no results are found, a   `200 OK` is returned with `totalItems: 0` and an empty list. - Supports pagination for handling large volumes of data. 
     * @summary Search Preowned products by productId or reference
     * @param {object} storeId Store ID
     * @param {string} [catalogIds] One or more Zara product identifiers (&#x60;productId&#x60;), separated by commas. The search will match the &#x60;catalogId&#x60; field in Preowned. Maximum allowed: 185 IDs or 2000 characters. Only this parameter or &#x60;references&#x60; can be sent, not both. 
     * @param {string} [references] Regular expression by garment type, brand, and season, it will not accept the size field. Maximum allowed: 185 references or 2000 characters. Only this parameter or &#x60;catalogIds&#x60; can be sent, not both. 
     * @param {string} [preownedIds] One or more unique Preowned identifiers, separated by commas. The search will match the &#x60;product.id&#x60; field in Preowned. Maximum allowed: 185 IDs or 2000 characters. Only this parameter, &#x60;catalogIds&#x60;, or &#x60;references&#x60; can be sent, not more than one. 
     * @param {number} [pageNumber] Page index (0..N).
     * @param {number} [pageSize] Number of items per page.
     * @param {string} [language] Language code for the response content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApiInterface
     */
    getPreownedProductsByIdOrReference(storeId: object, catalogIds?: string, references?: string, preownedIds?: string, pageNumber?: number, pageSize?: number, language?: string, options?: AxiosRequestConfig): AxiosPromise<PreownedProductsResponse>;

    /**
     * Returns filters based on actual search results to improve user experience by showing only relevant filter options
     * @summary Get contextual filters for products based on search criteria
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query] Search query string to filter results
     * @param {number} [minPublicationDateInMillis] Minimum publication date in milliseconds
     * @param {number} [maxPublicationDateInMillis] Maximum publication date in milliseconds
     * @param {Array<number>} [universeId] Universe identifier(s) to filter by
     * @param {Array<number>} [sizeId] Size identifier(s) to filter by
     * @param {Array<number>} [colorId] Color identifier(s) to filter by
     * @param {Array<number>} [conditionId] Condition identifier(s) to filter by
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {Array<number>} [categoryId] Category identifier(s) to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApiInterface
     */
    getProductSearchFiltersBySearch(storeId: number, query?: string, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, sizeId?: Array<number>, colorId?: Array<number>, conditionId?: Array<number>, sort?: Array<string>, lang?: string, categoryId?: Array<number>, options?: AxiosRequestConfig): AxiosPromise<SearchOptions>;

}

/**
 * ProductSearchApi - object-oriented interface
 * @export
 * @class ProductSearchApi
 * @extends {BaseAPI}
 */
export class ProductSearchApi extends BaseAPI implements ProductSearchApiInterface {
    /**
     * Returns information about one or more Preowned products using the Zara product identifier (`id`) or reference (`reference`). **Matching rules:** - If searching by `id` (productId), it will match the `catalogId` field in Preowned. - If searching by `reference`, it will match the `sku` field in Preowned. - Only **one of the two parameters** should be provided. If no results are found, a   `200 OK` is returned with `totalItems: 0` and an empty list. - Supports pagination for handling large volumes of data. 
     * @summary Search Preowned products by productId or reference
     * @param {object} storeId Store ID
     * @param {string} [catalogIds] One or more Zara product identifiers (&#x60;productId&#x60;), separated by commas. The search will match the &#x60;catalogId&#x60; field in Preowned. Maximum allowed: 185 IDs or 2000 characters. Only this parameter or &#x60;references&#x60; can be sent, not both. 
     * @param {string} [references] Regular expression by garment type, brand, and season, it will not accept the size field. Maximum allowed: 185 references or 2000 characters. Only this parameter or &#x60;catalogIds&#x60; can be sent, not both. 
     * @param {string} [preownedIds] One or more unique Preowned identifiers, separated by commas. The search will match the &#x60;product.id&#x60; field in Preowned. Maximum allowed: 185 IDs or 2000 characters. Only this parameter, &#x60;catalogIds&#x60;, or &#x60;references&#x60; can be sent, not more than one. 
     * @param {number} [pageNumber] Page index (0..N).
     * @param {number} [pageSize] Number of items per page.
     * @param {string} [language] Language code for the response content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    public getPreownedProductsByIdOrReference(storeId: object, catalogIds?: string, references?: string, preownedIds?: string, pageNumber?: number, pageSize?: number, language?: string, options?: AxiosRequestConfig) {
        return ProductSearchApiFp(this.configuration).getPreownedProductsByIdOrReference(storeId, catalogIds, references, preownedIds, pageNumber, pageSize, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns filters based on actual search results to improve user experience by showing only relevant filter options
     * @summary Get contextual filters for products based on search criteria
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [query] Search query string to filter results
     * @param {number} [minPublicationDateInMillis] Minimum publication date in milliseconds
     * @param {number} [maxPublicationDateInMillis] Maximum publication date in milliseconds
     * @param {Array<number>} [universeId] Universe identifier(s) to filter by
     * @param {Array<number>} [sizeId] Size identifier(s) to filter by
     * @param {Array<number>} [colorId] Color identifier(s) to filter by
     * @param {Array<number>} [conditionId] Condition identifier(s) to filter by
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {Array<number>} [categoryId] Category identifier(s) to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    public getProductSearchFiltersBySearch(storeId: number, query?: string, minPublicationDateInMillis?: number, maxPublicationDateInMillis?: number, universeId?: Array<number>, sizeId?: Array<number>, colorId?: Array<number>, conditionId?: Array<number>, sort?: Array<string>, lang?: string, categoryId?: Array<number>, options?: AxiosRequestConfig) {
        return ProductSearchApiFp(this.configuration).getProductSearchFiltersBySearch(storeId, query, minPublicationDateInMillis, maxPublicationDateInMillis, universeId, sizeId, colorId, conditionId, sort, lang, categoryId, options).then((request) => request(this.axios, this.basePath));
    }
}


